/**
 * @generated SignedSource<<39a7449b32a133dfd9c280d52fe78e39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CustomMcpServersSectionDeleteMutation$variables = {
  id: any;
};
export type CustomMcpServersSectionDeleteMutation$data = {
  readonly deleteCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly server: {
      readonly id: any;
    } | null | undefined;
  };
};
export type CustomMcpServersSectionDeleteMutation = {
  response: CustomMcpServersSectionDeleteMutation$data;
  variables: CustomMcpServersSectionDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "deleteCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomMcpServersSectionDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomMcpServersSectionDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79078e424884cc4d65ddb755bd1a9e7f",
    "id": null,
    "metadata": {},
    "name": "CustomMcpServersSectionDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CustomMcpServersSectionDeleteMutation(\n  $id: GlobalID!\n) {\n  deleteCustomMcpServer(id: $id) {\n    server {\n      id\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "792bd1eca1298a09b9834f194d0c9ea4";

export default node;
